<template>
  <el-select v-model="userId" :placeholder="placeholder" clearable filterable style="width:100%" @change="valueInput">
    <el-option v-for="user in list" :key="user.userId" :label="user.nickName + ' (' + user.phonenumber + ')'" :value="user.userId"/>
  </el-select>
</template>

<script>
import { listUserWithOutDataScope } from "@/api/system/user";

export default {
  name: "UserSelect",
  props: {
    value: {},
    placeholder: {
      type: String,
      default () {
        return "请选择用户"
      }
    }
  },
  data() {
    return {
      userId: this.value,
      list: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 999,
        status: null
      }
    };
  },
  created() {
    this.getList();
  },
  watch: {
    value (val) {
      this.userId = this.value
    }
  },
  methods: {
    getList() {
      listUserWithOutDataScope(this.queryParams).then(response => {
          this.list = response.rows;
        }
      );
    },
    valueInput (val) {
      this.$emit('input', val)
      this.$emit('selected', val)
    }
  }
};
</script>
